import { useTranslation } from 'next-i18next';
import { Box } from '@bridebook/ui';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import componentStyles from './search-suppliers-sign-up.style';
import { Button } from '@bridebook/aura';

const SearchSuppliersSignUp = () => {
  const { t } = useTranslation('search');
  const styles = componentStyles();

  return (
    <Box style={styles.wrapper} data-name="search-suppliers-sign-up">
      <Box>
        <Box as="h2" style={styles.heading}>
          {t('signUp.title')}
        </Box>
        <Box as="h3" style={styles.subheading}>
          {t('signUp.description')}
        </Box>
      </Box>
      <SignupLink>
        <Button size="lg" variant="primary" className="font-normal">
          {t('signUp.button')}
        </Button>
      </SignupLink>
    </Box>
  );
};

export default SearchSuppliersSignUp;
